var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkRound = function SvgCheckmarkRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "-1 -1 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M13.5.17c7.362 0 13.33 5.968 13.33 13.33S20.862 26.83 13.5 26.83.17 20.862.17 13.5 6.138.17 13.5.17m0 1.616C7.03 1.786 1.786 7.03 1.786 13.5S7.03 25.214 13.5 25.214 25.214 19.97 25.214 13.5 19.97 1.786 13.5 1.786m5.966 6.378c.31.317.311.823.007 1.142l-.015.015-8.974 8.904a.81.81 0 0 1-1.13.01l-.015-.015-3.351-3.373a.82.82 0 0 1 0-1.157.81.81 0 0 1 1.134-.015l.015.015 2.78 2.799 8.4-8.334a.81.81 0 0 1 1.15.009Z"
  })));
};
export default SvgCheckmarkRound;